import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { Utilities } from '../../shared/utilities';
import { UserService } from '../../shared/services/user.service';
import { GeneralService } from '../../shared/services/general.service';

@Component({
  templateUrl: './means-of-payment-registration-result.component.html',
  styleUrls: ['./means-of-payment-registration-result.component.css']
})

export class MeansOfPaymentRegistrationResultComponent implements OnInit, OnDestroy {

  public loading = true;
  public error = '';
  public message = '';
  public alert = '';
  public status: string = null;
  private operation: string = null;
  private paramMessage: string = null;
  private planId: string = null;
  public processing = false;
  public fingerprintData = {
    IdComercio: null,
    IdEnvironment: null,
    IdInvocacion: null
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private generalService: GeneralService
  ) {
    const that = this;
    that.route.queryParams.subscribe(params => {
      that.status = params.estado ? params.estado.toUpperCase() : null;
      that.operation = params.op ? params.op.toUpperCase() : null;
      that.paramMessage = params.mensaje ? params.mensaje : null;
      that.planId = params.planId ? params.planId.toUpperCase() : null;
      that.loadData();
    });
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  loadData(): void {
    const that = this;
    that.loading = true;

    forkJoin([that.generalService.getFingerprintData()])
      .subscribe(([getFingerprintDataResponse]) => {
          if (getFingerprintDataResponse) {
            that.fingerprintData.IdComercio = getFingerprintDataResponse.IdComercio;
            that.fingerprintData.IdEnvironment = getFingerprintDataResponse.IdEnvironment;
            that.fingerprintData.IdInvocacion = getFingerprintDataResponse.IdInvocacion;
            that.addFingerprint();

            if (that.status) {
              if (that.status === 'APROBADO' || that.status === 'RECHAZADO' || that.status === 'PENDIENTE' || that.status === 'ERROR') {
                if (that.operation) {
                  if (that.operation === 'MP' || that.operation === 'SN') {
                    if (that.status === 'APROBADO') {
                      if (that.operation === 'MP') {
                        that.message = `<p>Su medio de pago ha sido modificado correctamente.</p>`;
                      } else if (that.operation === 'SN') {
                        that.message = `<p>La suscripción se ha realizado correctamente.</p>`;
                      }
                    } else if (that.status === 'RECHAZADO') {
                      if (that.paramMessage) {
                        that.error = `<p>${that.paramMessage}</p>`;
                      } else {
                        that.error = `<p><b>Ha ocurrido un error.</b></p><p>Por favor, intente nuevamente o contáctenos.</p>`;
                      }
                    } else if (that.status === 'PENDIENTE') {
                      if (that.operation === 'MP') {
                        that.alert = '<p><b>La aprobación de su medio de pago se encuentra pendiente.</b></p><p>Por favor, intente nuevamente más tarde.</p>';
                      } else if (that.operation === 'SN') {
                        that.alert = '<p><b>La aprobación de su suscripción se encuentra pendiente.</b></p><p>Por favor, intente nuevamente más tarde.</p>';
                      }
                    } else if (that.status === 'ERROR') {
                      if (that.paramMessage) {
                        that.error = `<p>${that.paramMessage}</p>`;
                      } else {
                        that.error = `<p><b>Ha ocurrido un error.</b></p><p>Por favor, intente nuevamente o contáctenos.</p>`;
                      }
                    }
                  } else {
                    that.status = null;
                    that.error = `<p><b>Error.</b></p><p>No se conoce la operación que intentaba realizar.</p>`;
                  }
                } else {
                  that.status = null;
                  that.error = `<p><b>Error.</b></p><p>No se ha podido identificar qué operación intentaba realizar.</p>`;
                }
              } else {
                that.error = `<p><b>Error.</b></p><p>No se conoce el resultado de la operación que intentaba realizar.</p>`;
              }
            } else {
              that.error = `<p><b>Error.</b></p><p>No se ha podido identificar el resultado de la operación que intentaba realizar.</p>`;
            }
            that.loading = false;
          } else {
            that.error = `<p><b>Ha ocurrido un error.</b></p><p>Por favor, intente nuevamente.</p>`;
          }
      },
      (error) => {
        Utilities.logError('Error al obtener el fingerprint');
        Utilities.logError(error);
        that.loading = false;
        that.error = `<p><b>Ha ocurrido un error.</b></p><p>Por favor, intente nuevamente.</p>`;
      });
  }

  public retry(): void {
    if (this.planId) {
      if (this.operation === 'SN') {
        this.subscribeToPlan(this.planId);
      } else if (this.operation === 'MP') {
        this.changeMeanOfPayment(this.planId);
      }
    } else {
      this.error = `<p><b>Error.</b></p><p>No se ha podido identificar el plan asociado a la operación que intenta realizar.</p>`;
    }
  }

  public goTo(url): void {
    this.router.navigate([url]);
  }

  private subscribeToPlan(planId: string): void {
    const that = this;
    const fingerprint = that.fingerprintData.IdInvocacion;
    if (!that.processing) {
      that.error = '';
      that.message = '';
      that.alert = '';
      that.processing = true;
      that.loading = true;
      forkJoin([
        that.userService.subscribeToPlan(planId, fingerprint)
      ]).subscribe(([subscribeToPlanResponse]) => {
          if (subscribeToPlanResponse) {
            if (!subscribeToPlanResponse.HasError) {
              // Si en la respuesta no viene error y viene UrlToPlexo, mando al usuario a esa pantalla.
              if (subscribeToPlanResponse.UrlToPlexo && subscribeToPlanResponse.UrlToPlexo.length > 0) {
                window.location.href = subscribeToPlanResponse.UrlToPlexo;
              } else {
                const navigationExtras: NavigationExtras = {
                  queryParams: {planId}
                };
                that.router.navigate(['resultado-de-suscripcion'], navigationExtras);
              }
            } else {
              if (subscribeToPlanResponse.ErrorMessage){
                that.error = `<p><b>¡Error!</b></p><p>${subscribeToPlanResponse.ErrorMessage}</p>`;
              } else {
                that.error = '<p>Ha ocurrido un error, por favor, intente nuevamente.</p>';
              }
            }
          } else {
            that.error = '<p>Ha ocurrido un error, por favor, intente nuevamente.</p>';
          }
          that.processing = false;
          that.loading = false;
        },
        (error) => {
          Utilities.logError('Error al suscribirse a un plan');
          Utilities.logError(error);
          that.processing = false;
          that.loading = false;
          localStorage.clear();
          that.error = '<p><b>Ha ocurrido un error.</b></p><p>Por favor, intente nuevamente.</p>';
        });
    }
  }

  private changeMeanOfPayment(planId: string): void {
    const that = this;
    const fingerprint = that.fingerprintData.IdInvocacion;
    if (!that.processing) {
      that.error = '';
      that.message = '';
      that.alert = '';
      that.processing = true;
      that.loading = true;
      forkJoin([
        that.userService.changeMeanOfPayment(planId, fingerprint)
      ]).subscribe(([changeMeanOfPaymentResponse]) => {
          if (changeMeanOfPaymentResponse) {
            if (!changeMeanOfPaymentResponse.HasError) {
              // Si en la respuesta no viene error y viene UrlToPlexo, mando al usuario a esa pantalla.
              if (changeMeanOfPaymentResponse.UrlToPlexo && changeMeanOfPaymentResponse.UrlToPlexo.length > 0) {
                window.location.href = changeMeanOfPaymentResponse.UrlToPlexo;
              }
            } else {
              if (changeMeanOfPaymentResponse.ErrorMessage){
                that.error = `<p><b>¡Error!</b></p><p>${changeMeanOfPaymentResponse.ErrorMessage}</p>`;
              } else {
                that.error = '<p>Ha ocurrido un error, por favor, intente nuevamente.</p>';
              }
            }
          } else {
            that.error = '<p>Ha ocurrido un error, por favor, intente nuevamente.</p>';
          }
          that.processing = false;
          that.loading = false;
        },
        (error) => {
          Utilities.logError('Error al cambiar el medio de pago');
          Utilities.logError(error);
          that.processing = false;
          that.loading = false;
          localStorage.clear();
          that.error = '<p><b>Ha ocurrido un error.</b></p><p>Por favor, intente nuevamente.</p>';
        });

    }
  }

  private addFingerprint(): void {
    const that = this;
    if (
      that.fingerprintData &&
      that.fingerprintData.IdEnvironment &&
      that.fingerprintData.IdComercio &&
      that.fingerprintData.IdInvocacion
    ) {
      // Si antes de agregar el script del fingerprint ya existía uno, lo elimino.
      that.deleteFingerprint();
      // Genero el script para el fingerprint
      const scriptSRC = `https://h.online-metrix.net/fp/tags.js?org_id=${that.fingerprintData.IdEnvironment}&session_id=${that.fingerprintData.IdComercio}${that.fingerprintData.IdInvocacion}`;
      const scriptTag = document.createElement('script');
      scriptTag.id = 'fingerprintScript';
      scriptTag.type = 'text/javascript';
      scriptTag.src = scriptSRC;
      // Agrego el script necesario para el fingerprint
      document.getElementsByTagName('head')[0].appendChild(scriptTag);
    }
  }

  private deleteFingerprint(): void {
    const existingScriptTag = document.getElementById('fingerprintScript');
    if (existingScriptTag) {
      document.getElementsByTagName('head')[0].removeChild(existingScriptTag);
    }
    /*const existingIframes = document.getElementsByTagName('iframe');
    if (existingIframes && existingIframes.length > 0) {
      document.getElementsByTagName('body')[0].removeChild(existingIframes[0]);
    }*/
  }
}
